import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

//Catálogo categorías
export const createCategoriaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}${"/createCategoria"}`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
/*export const getCategoriasHttp = async (search?: string) => {
  try {
    const url = new URL(`${env.API_URL}/getCategorias`);
    if (search) url.searchParams.append("search", search);

    const response = await axios.get(url.toString());
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};*/
export const getCategoriasHttp = async (params?: {
  search?: string;
  id_tipo_producto?: string | number;
}) => {
  try {
    const url = new URL(`${env.API_URL}/getCategorias`);

    if (params?.search) url.searchParams.append("search", params.search);
    if (params?.id_tipo_producto)
      url.searchParams.append("id_tipo_producto", String(params.id_tipo_producto));

    const response = await axios.get(url.toString());
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const editarCategoriaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(`${env.API_URL}/editarCategoria`, data);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const desactivarCategoriaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(
      `${env.API_URL}/desactivarCategoria`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const activarCategoriaHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(`${env.API_URL}/activarCategoria`, data);
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
